import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/workouts.css';

// Swap these Cloudinary URLs anytime to change the tile images
const TWENTYFIVE_TILE_IMAGE = 'https://res.cloudinary.com/da3ouwgdr/image/upload/v1791315648/25_for_25_uf1o87.png';
const BUILDER_TILE_IMAGE = 'https://res.cloudinary.com/da3ouwgdr/image/upload/v1791315645/FreeWorkoutBuilderChatGPT_Image_Oct_6_2026_03_40_04_PM_yvwt8l.png';

const WorkoutsPage = () => {
  useEffect(() => {
    document.title = 'Workouts | GoCalFit';
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'Strength workouts from GoCalFit — the 25 for 25 workout pack and a free build-your-own workout tool. Bodyweight-first, no gym needed.');
  }, []);

  return (
    <div className="workouts-hub" data-testid="workouts-hub">
      <section className="services-section workouts-hub-section">
        <div className="services-intro">
          <h2 className="section-title">Workouts</h2>
          <p className="section-subtitle">Strength you can do anywhere</p>
        </div>

          <div className="services-grid workouts-hub-grid">
          {/* Tile 1 — Free builder */}
          <Link to="/workouts/builder" className="service-card service-card-with-image workouts-tile-builder" data-testid="workouts-tile-builder">
            <div className="service-card-glow"></div>
            <div className="service-card-image-container">
              <img
                src={BUILDER_TILE_IMAGE}
                alt="Build your own workout"
                className="service-card-image"
              />
            </div>
            <div className="service-card-content">
              <div className="service-subtitle-badge badge-free">Free</div>
              <h3 className="service-title">Build Your Own Workout</h3>
              <p className="workouts-tile-subhead">Pick your time, your space, and your focus. Get a workout in seconds.</p>
              <p className="service-description">
                No equipment, no signup. Choose 25 or 35 minutes, inside or outside, full body, upper, or core.
              </p>
              <div className="service-cta">
                Build My Workout
                <span className="arrow">→</span>
              </div>
            </div>
          </Link>

          {/* Tile 2 — 25 for 25 */}
          <Link to="/25-for-25" className="service-card service-card-with-image workouts-tile-featured" data-testid="workouts-tile-25for25">
            <div className="service-card-glow"></div>
            <div className="service-card-image-container">
              <img
                src={TWENTYFIVE_TILE_IMAGE}
                alt="25 for 25 strength workouts"
                className="service-card-image"
              />
            </div>
            <div className="service-card-content">
              <h3 className="service-title">25 for 25</h3>
              <p className="workouts-tile-subhead">25 bodyweight workouts. 25 minutes each. One $25 pack.</p>
              <p className="service-description">
                No thinking. No overthinking. Just moving, so it's not a zero day.
              </p>
              <div className="service-cta">
                See what's inside
                <span className="arrow">→</span>
              </div>
            </div>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default WorkoutsPage;
